<script>
    /**
     * SPDX-FileCopyrightText: 2012-2026 Open Assessment Technologies S.A.
     * Copyright (C) 2026 (original work) Open Assessment Technologies S.A.
     *
     * SPDX-License-Identifier: AGPL-3.0-only OR LicenseRef-TAO-Commercial-License
     */
    import { Tooltip } from '@oat-sa-private/ui-components';

    let { attributes = {} } = $props();

    //anchor element svelte binding
    let anchorElement = $state();
</script>

<style>
    .tooltip-target {
        color: var(--color-text-default);
        text-decoration: underline;
        cursor: pointer;

        &:hover {
            color: var(--color-text-link-hover);
        }
        &:focus-visible {
            color: var(--color-text-link-hover);
        }

        @add-mixin outline-focus 0;
    }
</style>

<!-- svelte-ignore a11y_no_noninteractive_tabindex -->
<span class="tooltip-target" bind:this={anchorElement} tabindex="0">
    {attributes.content ? attributes.content : ''}
</span>

<Tooltip text={attributes.text} {anchorElement} />
